export * from './crud-service.class';
